var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLoaderSport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 116,
  height: 116,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#292C33",
  d: "M100 62c0 27.614-22.386 50-50 50S0 89.614 0 62s22.386-50 50-50 50 22.386 50 50m-89 0c0 21.54 17.46 39 39 39s39-17.46 39-39-17.46-39-39-39-39 17.46-39 39"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#loaderSport_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M95 62c2.761 0 5.026-2.244 4.75-4.992A50 50 0 0 0 54.992 12.25C52.244 11.974 50 14.239 50 17s2.247 4.968 4.987 5.312a40 40 0 0 1 34.7 34.701C90.033 59.753 92.24 62 95 62"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "loaderSport_svg__a",
  width: 81.773,
  height: 81.773,
  x: 34,
  y: 0.227,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_35151_501270"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_35151_501270",
  result: "shape"
})))));
export default SvgLoaderSport;